import { useState, useEffect } from "react";
import Contact from "./views/Contact";
import Navbar from "./components/Navbar";
import About from "./views/About";
import Home from './views/Home'
import Skills from "./views/Skills";
import Projects from "./views/Projects";
import Experience from "./views/Experience";
import LoadingScreen from "./components/LoadingScreen";
import { ThemeProvider } from "./themeProvider";
import Githubstatus from "./views/Githubstatus";
// import Skills from "./views/Services";


function App() {
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    setTimeout(() => setLoading(false), 1000)
  }, [])

  return (
    <ThemeProvider>
      <>
        {!loading ? (
          <div >
            <Navbar />
            <Home />
            <About />
            <Experience />
            <Skills />
            <Projects />
            <Githubstatus />
            <Contact />
          </div>

        ) : (
          <LoadingScreen />
        )}
      </>
    </ThemeProvider>

  );
}

export default App;
